import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Utility component to ensure the page scrolls to the top on navigation
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}